import React, { Component } from 'react';
import PropTypes from 'prop-types';

const thresholdNext = {
  md: 'lg',
  sm: 'md',
  xs: 'sm',
};

class StoreMobileTable extends Component {
  static propTypes = {
    children: PropTypes.node,
    threshold: PropTypes.string,
  };

  static defaultProps = {
    children: null,
    threshold: 'md',
  };

  render() {
    const { children, threshold } = this.props;

    return (
      <div className={`d-${thresholdNext[threshold]}-up-none`}>
        {children}
      </div>
    );
  }
}

export default StoreMobileTable;
